import { Injectable } from '@angular/core';

@Injectable()
export class BrowserCacheService {
  private _cacheId: string;

  constructor() {
  }

  generateCacheId(): void {
    this._cacheId = Date.now() + "_" + Math.random();
  }

  getCacheId(): string {
    return this._cacheId;
  }
}
